<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Főoldal</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <!--ion-card color="primary">
    <ion-card-header>
      <ion-card-title><ion-icon name="alert-circle-outline"></ion-icon> Üdvözöljük a Sulinform felületén!</ion-card-title>
      <ion-card-subtitle>Válasszon a menük közül!</ion-card-subtitle>
    </ion-card-header>
  </ion-card-->
  <ion-card *ngIf="loginMode == 'dolgozo' && adatok">
    <ion-card-header>
      <ion-card-title>Bankszámla

      </ion-card-title>
    </ion-card-header>
    <ion-card-content style="margin:0 !important;padding: 0 !important;">
      <ion-item>
        <ion-input label="Számlaszám:" [(ngModel)]="adatok.iban"></ion-input>
        <ion-input label="Főkönyvi szám:" [(ngModel)]="adatok.fokszam"></ion-input>
      </ion-item>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="loginMode == 'dolgozo'">
    <ion-card-header>
      <ion-card-title>Kontírozás
        <ion-button style="float:right;margin:0 !important" size="small" color="light" (click)="kuldes()">
          Küldés könyvelésre
        </ion-button>

      </ion-card-title>
    </ion-card-header>
    <ion-card-content style="margin:0 !important;padding: 0 !important;">

      <ion-card *ngIf="suggestedMatches.length" color="warning" style="margin: 8px;">
        <ion-card-header>
          <ion-card-title>Javasolt párosítások (SUGGESTED_MATCH)</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <ion-list>
            <ion-item *ngFor="let s of suggestedMatches">
              <ion-label>
                <h3>{{s.docNo}} - {{s.amount | currency: 'HUF' : '' : '0.0'}} {{s.currency}}</h3>
                <p>{{ getSuggestedMatchPartnerLabel(s) }} | {{s.date}}</p>
                <p *ngIf="s.text">{{s.text}}</p>
              </ion-label>
              <ion-button size="small" color="success" (click)="acceptSuggestedMatch(s)">Elfogad</ion-button>
              <ion-button size="small" color="medium" fill="outline" (click)="rejectSuggestedMatch(s)">Elutasít</ion-button>
            </ion-item>
          </ion-list>
        </ion-card-content>
      </ion-card>

      <ion-grid>
        <ng-container *ngFor="let item of kontirLista">
          <ion-row
            style="border-bottom: 2px solid black">
            <ion-col>
              <ion-card style="">
                <ion-card-header [color]="getHeaderColor(item)">
                  <ion-card-title>Bank</ion-card-title>
                </ion-card-header>
                <ion-card-content style="margin:0 !important;padding: 0 !important;">

                  <ion-list>
                    <ion-item> <ion-checkbox style="width: 20px;" *ngIf="item.szabaly=='b'"
                      [(ngModel)]="item.szabalyfeltetel[0]" (ngModelChange)="onItemEdited(item)"></ion-checkbox>

                      <ion-input label="Dátum:" [value]="item.date"></ion-input>
                    </ion-item>
                    <ion-item>
                      <ion-label>Összeg: {{item.amount| currency: 'HUF' : '' : '0.0'}} {{item.currency}} /
                        {{item.reszosszeg| currency: 'HUF' : '' : '0.0'}} {{item.currency}}
                        ({{item.amount-item.reszosszeg| currency: 'HUF' : '' : '0.0'}} {{item.currency}})</ion-label>
                    </ion-item>
                    <ion-item *ngIf="item.devizaAmount">
                      <ion-label>Dev. összeg: {{item.devizaAmount| currency: 'HUF' : '' : '0.0'}}
                        {{item.devizaCur}}<br>Árfolyam: {{item.arfolyam}} HUF</ion-label>
                    </ion-item>
                    <ion-item>
                      <ion-checkbox style="width: 20px;" *ngIf="item.szabaly=='b'"
                      [(ngModel)]="item.szabalyfeltetel[1]" (ngModelChange)="onItemEdited(item)"></ion-checkbox>
                      <ion-input label="Partner:"
                        [ngModel]="getEditablePartner(item)"
                        (ngModelChange)="setEditablePartner(item, $event)"></ion-input>
                    </ion-item>
                    <ion-item *ngIf="item.text">
                       <ion-checkbox style="width: 20px;" *ngIf="item.szabaly=='b'"
                      [(ngModel)]="item.szabalyfeltetel[2]" (ngModelChange)="onItemEdited(item)"></ion-checkbox>
                      <ion-input label="Közl.:"
                        [ngModel]="getEditableText(item)"
                        (ngModelChange)="setEditableText(item, $event)"></ion-input>

                    </ion-item>
                    <ion-item *ngIf="item.bankAccountNumber">
                      <ion-checkbox style="width: 20px;" *ngIf="item.szabaly=='b'"
                      [(ngModel)]="item.szabalyfeltetel[3]" (ngModelChange)="onItemEdited(item)"></ion-checkbox>
                      <ion-input label="Bankszámlaszám:" [value]="item.bankAccountNumber"></ion-input>
                    </ion-item>
                  </ion-list>

                </ion-card-content>

              </ion-card>
            </ion-col>
            <ion-col>
              <ion-card>
                <ion-card-header [color]="getHeaderColor(item)">
                  <ion-card-title>{{ getKontirLabel(item) }}
                    <ion-button *ngIf="item.szabaly" style="float:right;margin:0 !important" size="small"
                      [color]="item.szabaly=='a' ?'light':'success'"
                      [disabled]="item.tipus=='x' || item.docType=='KIEGYENLITES'"
                      (click)="toggleSzabaly(item)">
                      Új szabály
                    </ion-button>
                    <ion-button *ngIf="item._edited" style="float:right;margin:0 6px 0 0 !important" size="small"
                      color="warning" (click)="restoreItem(item)">
                      Visszaállítás
                    </ion-button>
                  </ion-card-title>
                </ion-card-header>
                <ion-card-content style="margin:0 !important;padding: 0 !important;">

                  <ion-list>
                    <ion-item>
                      <ion-label>Státusz: {{item.matchStatus.includes('posted_rule')?'Szabállyal
                        párosítva!':statusz[item.docType]}}</ion-label>
                    </ion-item>
                    <ion-item *ngIf="item.hardcodedRuleName">
                      <ion-label>Beégetett szabály: {{item.hardcodedRuleName}}</ion-label>
                    </ion-item>
                    <ion-item *ngIf="item.linkKey">
                      <ion-label>{{item.linkKey}}</ion-label>
                    </ion-item>
                    <ion-item>
                      <ion-label>Típus: </ion-label>
                      <select (change)="tipusChange($event,item.docNo)" [(ngModel)]="item.tipus"
                        [disabled]="item.docType!='NEEDS_REVIEW_POSTED'">
                        <option value="x">Függő</option>
                        <option value="a">Bankköltség</option>
                        <option value="b">Szállító</option>
                        <option value="c">Vevő</option>
                        <option value="d">Egyéb</option>
                      </select>
                    </ion-item>
                    <ion-item>
                      <ion-input label="T" [(ngModel)]="item.tartozik" (ngModelChange)="onItemEdited(item)"></ion-input>
                      <ion-input label="K" [(ngModel)]="item.kovetel" (ngModelChange)="onItemEdited(item)"></ion-input>
                    </ion-item>
                    <ion-item *ngIf="item.tipus=='b' || item.tipus=='c'">
                      <ng-select (change)="changedSelect(item)" [(ngModel)]="item.kontir" appendTo="body"
                        [notFoundText]="'Nincs találat'" [items]="item.eloirasOptions || []" bindValue="docNo" [multiple]="true"
                        [closeOnSelect]="true" bindLabel="mutat">
                        <ng-template ng-option-tmp let-item="item" style="line-height: 1em !important;">
                          {{ item.docNo }} - {{item.amount| currency: 'HUF' : '' : '0.0'}} {{item.currency}}<br />
                          <small>{{ item.partnerAzonosito || item.partnerCode }} {{item.partner}}<br>{{ item.date }}</small>
                        </ng-template>
                      </ng-select>
                    </ion-item>
                    <ion-item *ngIf="item.tipus=='b' || item.tipus=='c'">
                      <div style="width:100%">
                        <ion-label style="display:block;margin-bottom:6px;">Partner:</ion-label>
                        <ng-select
                          appendTo="body"
                          [items]="partnerOptions || []"
                          [(ngModel)]="item.selectedPartner"
                          [notFoundText]="partnerOptionsLoading ? 'Partnerek betoltese...' : 'Nincs talalat'"
                          bindLabel="partnerDisplay"
                          [clearable]="true"
                          (open)="loadPartnerOptions(true, item)"
                          (change)="onPartnerSelected(item, $event)">
                          <ng-template ng-option-tmp let-item="item">
                            {{ item.partnerDisplay }}
                          </ng-template>
                        </ng-select>
                      </div>
                    </ion-item>
                  </ion-list>

                </ion-card-content>

              </ion-card>
            </ion-col>
          </ion-row>
        </ng-container>
      </ion-grid>

    </ion-card-content>

  </ion-card>

  <ion-modal class="" style="z-index: 1000" #feljegyzesmodal>
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="close()">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Feljegyzés</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="margin: auto">
        {{f.tantargy_nev}} - {{f.targynap}} - {{f.dvez}} {{f.dker}}<br>
        {{f.szoveg || f.tema || f.ertekeles || "-"}}<br>
        <i>{{f.tvez}} {{f.tker}} {{f.db=='ertekeles' && f.tipus !="-" ? "- "+f.tipus : ""}}</i>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
